// Обработка формы контактов через AJAX
document.addEventListener('DOMContentLoaded', function() {
	const form = document.getElementById('contact-form');
	if (!form) return;
	
	form.addEventListener('submit', function(e) {
		e.preventDefault();
		
		const formData = new FormData(form);
		const submitBtn = form.querySelector('button[type="submit"]');
		const originalText = submitBtn.innerHTML;
		
		// Показываем загрузку
		submitBtn.disabled = true;
		submitBtn.innerHTML = '<span>Отправка...</span>';
		
		// Отправляем форму через ajax.php
		fetch('/ajax.php?mod_id=mod_anketa', {
			method: 'POST',
			body: formData,
			headers: {
				'X-Requested-With': 'XMLHttpRequest'
			}
		})
		.then(response => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response.json();
		})
		.then(data => {
			if (data.success) {
				// Показываем блок успеха
				const formWrapper = form.closest('.contact-form-wrapper');
				if (formWrapper) {
					const successHTML = `
						<div class="contact-form-success bg-white rounded-2xl p-8 shadow-2xl text-center">
							<div class="success-icon mx-auto mb-6 w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
								<svg class="w-12 h-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
								</svg>
							</div>
							<h3 class="text-2xl font-bold text-gray-900 mb-4">Спасибо!</h3>
							<p class="text-gray-600 mb-6">${data.message || 'Ваша заявка успешно отправлена. Мы свяжемся с вами в ближайшее время.'}</p>
							<button class="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-lg transition-all" onclick="location.reload()">Отправить еще одну заявку</button>
						</div>
					`;
					formWrapper.innerHTML = successHTML;
					
					// Прокручиваем к блоку успеха
					setTimeout(() => {
						const contactSection = document.getElementById('contact');
						if (contactSection) {
							contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
						}
					}, 100);
				}
			} else {
				// Показываем ошибку
				alert(data.error || 'Произошла ошибка при отправке заявки. Пожалуйста, попробуйте еще раз.');
					submitBtn.disabled = false;
					submitBtn.innerHTML = originalText;
			}
		})
		.catch(error => {
			console.error('Error:', error);
			alert('Произошла ошибка при отправке заявки. Пожалуйста, попробуйте еще раз.');
			submitBtn.disabled = false;
			submitBtn.innerHTML = originalText;
		});
	});
});









